// ESC/POS 指令拼装（纯字节，不依赖第三方打印机库）
// 中文用 GBK 编码（得力等国产热敏打印机内置字库默认 GBK）
import iconv from 'iconv-lite';

// 把字符串按 GBK 编码压入字节数组
function pushText(bytes, s) {
  const buf = iconv.encode(String(s), 'gbk');
  for (let i = 0; i < buf.length; i++) bytes.push(buf[i]);
}

/**
 * 生成小票的 ESC/POS 字节流
 * @param {Object} opts
 *   storeName  店名（标题，居中加大加粗）
 *   type       'sale' | 'purchase'
 *   date       日期字符串
 *   items      [{ name, quantity, price, subtotal }]
 *   total      合计金额
 *   footer     页脚（默认 谢谢惠顾）
 * @returns {Uint8Array}
 */
export function buildReceiptBytes({ storeName, type, date, items, total, footer }) {
  const b = [];
  const cmd = (...xs) => b.push(...xs);

  // 初始化 + 进入中文模式
  cmd(0x1b, 0x40);        // ESC @  初始化打印机
  cmd(0x1c, 0x26);        // FS &   进入中文模式（双字节内码，GBK）

  // 标题：店名（居中 + 加粗 + 倍大）
  cmd(0x1b, 0x61, 0x01);  // 居中
  cmd(0x1b, 0x45, 0x01);  // 加粗
  cmd(0x1d, 0x21, 0x11);  // GS !  倍宽倍高
  pushText(b, (storeName || '店铺名') + '\n');
  cmd(0x1d, 0x21, 0x00);  // 恢复字号
  cmd(0x1b, 0x45, 0x00);  // 取消加粗

  // 单据类型
  pushText(b, (type === 'purchase' ? '── 进货单 ──' : '── 销售单 ──') + '\n\n');

  // 分隔线（80mm 纸 48 字符宽，58mm 纸 32 字符宽；这里用 32 兼容两者）
  pushText(b, '--------------------------------\n');

  // 商品明细（左对齐，每条两行：名称 / 数量x单价=小计）
  cmd(0x1b, 0x61, 0x00);  // 左对齐
  (items || []).forEach(it => {
    pushText(b, String(it.name || '') + '\n');
    const qty = Number(it.quantity) || 0;
    const price = Number(it.price) || 0;
    const sub = Number(it.subtotal) || qty * price;
    pushText(b, `  ${qty} x ${price.toFixed(2)} = ${sub.toFixed(2)}\n`);
  });

  pushText(b, '--------------------------------\n');

  // 合计（右对齐 + 加粗）
  cmd(0x1b, 0x61, 0x02);
  cmd(0x1b, 0x45, 0x01);
  pushText(b, `合计: ${(Number(total) || 0).toFixed(2)} 元\n`);
  cmd(0x1b, 0x45, 0x00);

  // 日期 + 页脚（居中）
  cmd(0x1b, 0x61, 0x01);
  if (date) pushText(b, String(date) + '\n');
  pushText(b, '\n' + (footer || '谢谢惠顾') + '\n\n\n');

  // 切纸
  cmd(0x1d, 0x56, 0x42, 0x00);  // GS V B 0 全切

  return new Uint8Array(b);
}

/**
 * 生成测试打印字节流（验证清晰度用）
 */
export function buildTestBytes() {
  return buildReceiptBytes({
    storeName: '打印测试',
    type: 'sale',
    date: new Date().toLocaleString('zh-CN'),
    items: [
      { name: '可口可乐', quantity: 2, price: 3.0 },
      { name: '雪碧', quantity: 1, price: 3.5 }
    ],
    total: 9.5,
    footer: '谢谢惠顾'
  });
}